import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import {
  AfBoxExternalIcon,
  AkFeedbackIcon,
  AkSettingsIcon,
} from '@fuegokit/fuegoicons-react';

import { buildSupportUrl } from '../../services/feedback';
import { getContext } from '../../services/jira';
import { getInstanceUrlWithCallback } from '../../services/jira';

interface ExternalLinksProps {
  mainPage?: boolean;
}

export function ExternalLinks({ mainPage = false }: ExternalLinksProps) {
  const appearance = mainPage ? 'default' : 'subtle';

  function onSupportClick() {
    getInstanceUrlWithCallback(goToSupportPortal);
  }

  async function goToSupportPortal(instanceUrl: string) {
    const url = await buildSupportUrl(instanceUrl);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  async function goToConfigurationPage() {
    const { jira } = await getContext();
    AP.navigator.go('site', {
      relativeUrl: `/plugins/servlet/ac/toggl/jira-toggl-top?project.key=${jira.project.key}&project.id=${jira.project.id}#!/configuration`,
    });
  }
  return (
    <>
      <Tooltip content="Open toggle.com">
        <Button
          iconBefore={<AfBoxExternalIcon size={24} />}
          appearance={appearance}
          href={`https://track.toggl.com/timer`}
          target="_blank"
        >
          {mainPage ? 'toggl.com' : ''}
        </Button>
      </Tooltip>
      <Tooltip content="Contact us">
        <Button
          iconBefore={<AkFeedbackIcon size={24} />}
          appearance={appearance}
          onClick={onSupportClick}
        >
          {mainPage ? 'Contact us' : ''}
        </Button>
      </Tooltip>
      {!mainPage && (
        <Tooltip content="App configuration">
          <Button
            iconBefore={<AkSettingsIcon size={24} />}
            appearance={appearance}
            onClick={() => void goToConfigurationPage()}
          ></Button>
        </Tooltip>
      )}
    </>
  );
}
